var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal-title-list-view modal-native-button-table",
      attrs: { id: _vm.id }
    },
    [
      _c("h4", { staticClass: "title" }, [_vm._v("Edit Button")]),
      _vm._v(" "),
      _c(
        "b-form",
        { class: { "error-input": _vm.$v.dataSetup.label.$error } },
        [
          _c("label", [_vm._v(" Label ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: {
              "error-required": false,
              placeholder: "Enter button label"
            },
            model: {
              value: _vm.dataSetup.label,
              callback: function($$v) {
                _vm.$set(_vm.dataSetup, "label", $$v)
              },
              expression: "dataSetup.label"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form",
        { staticClass: "mt-2" },
        [
          _c("label", [_vm._v("Hidden Button")]),
          _vm._v(" "),
          _c("j-toggle", {
            staticClass: "toggle",
            model: {
              value: _vm.dataSetup.is_hidden,
              callback: function($$v) {
                _vm.$set(_vm.dataSetup, "is_hidden", $$v)
              },
              expression: "dataSetup.is_hidden"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex justify-content-end" }, [
        _c(
          "button",
          {
            staticClass: "button-border mr-2",
            on: {
              click: function($event) {
                _vm.$emit("close-modal")
              }
            }
          },
          [_vm._v("\n      Close\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "button-blue", on: { click: _vm.submitForm } },
          [_vm._v("\n      Apply\n    ")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75e41225", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75e41225","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/popup/ModalNativeButtonTable.vue
// module id = null
// module chunks = 